import React from 'react'
import './HomePage.css'
import girl1 from '../../images/girl-1.png'
import girl2 from '../../images/girl-2.png'
import Button from '../Button/Button'
import EnrolButton from '../EnrolButton/EnrolButton'
import InfoPack from '../AboutPage/InfoPack.pdf'
import DanceStyles from '../DanceStyles/DanceStyles'

const HomePage = () => {
  return (
  <div className='home-page'>
    {/* Hero Section */}
    <section className='hero-section'>
      <div className='hero-content'>
        <div className='hero-images'>
          <div className='img-wrapper-left'>
            <img src={girl2} alt='CC Choreography'/>
          </div>
          <div className='img-wrapper-right'>
            <img src={girl1} alt='CC Choreography'/>
          </div>
        </div>
        <div className='hero-text'>
          <h1 className='cc-choreography'>CC Choreography</h1>
          <h2 className='tag-line'>Join our dance family today</h2>
        </div>
      </div>
    </section>

    {/* CTA Section */}
    <section className='action-section'>
      <div className='cta-container'>
        <EnrolButton />
        <Button href={InfoPack} download text='Download Info Pack' />
        <Button href='/about#free-trial' text='Free Trial' />
      </div>
    </section>

    {/* Dance Styles Section */}
    <section className='home-dance-styles-section'>
      <DanceStyles allowWrap={true} />
    </section>
  </div>
  )
}

export default HomePage
